<div class="units-container">
  <h3>Units using this {{ parentEntityName }}</h3>
  <p><em>Drag-and-drop to reorder.</em></p>

  @if (unitsGroupedByAge.length === 0) {
    <div class="no-units"> No units are currently using this {{ parentEntityName.toLowerCase() }}. </div>
  }

  @if (unitsGroupedByAge.length > 0) {
    <div class="age-groups">
      <div *ngFor="let ageGroup of unitsGroupedByAge; let ageIndex = index" class="age-group">
        <h4 class="age-title">{{ ageGroup.ageTitle }}</h4>

        @if (ageGroup.hasChanges) {
          <div class="unsaved-changes-warning"> ⚠️ There are unsaved changes; changes are not saved until you save the {{ parentEntityName }}. </div>
        }

        <div class="units-list" cdkDropList [cdkDropListData]="ageGroup.units" (cdkDropListDropped)="onUnitDropped($event, ageIndex)">
          <div *ngFor="let unit of ageGroup.units" class="unit-item" cdkDrag>
            <div class="drag-handle" cdkDragHandle>
              <span class="unit-order">☰</span>
            </div>
            <span class="unit-title">
              <strong>{{ unit.title }}</strong>
            </span>
            <span class="unit-status">
              Status:
              <img
                [src]="unit.status === 'active' ? '/assets/images/icons/status-active.svg' : '/assets/images/icons/status-inactive.svg'"
                [alt]="unit.status"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  }
</div>
